import React from 'react';
import { Link } from "react-router-dom";
import { useLocalizedData } from '../hooks/useTranslatedContent';

export default function BlogData({ enterprisesData }) {
    const { getLocalizedArray } = useLocalizedData(enterprisesData);
    const enterprises = getLocalizedArray('enterprises') || [];

    if (!enterprises || !enterprisesData) {
        return null;
    }

    const isExternalLink = (url) => typeof url === 'string' && /^https?:\/\//.test(url);

    return (
        <div className="container py-12 space-y-12">
            {enterprises.map((item, index) => {
                if (!item || (!item.title && !item.description)) return null;

                const isEven = index % 2 === 0;

                return (
                    <div
                        key={item.id || `blog-${index}`}
                        className={`flex flex-col md:flex-row ${!isEven ? 'md:flex-row-reverse' : ''} 
        items-center bg-white dark:bg-slate-900 rounded-md overflow-hidden 
        transition-all duration-300 
        hover:shadow-lg`}
                    >
                        <div className="w-full md:w-1/2 h-72 md:h-96">
                            <img
                                src={item.img || '/default-blog.jpg'}
                                alt={item.title || 'Blog post'}
                                className="w-full h-full object-cover"
                            />
                        </div>

                        <div className="w-full md:w-1/2 p-6">
                            {/* ICON LINK */}
                            {item.icon && (
                                <div className="mb-4">
                                    {item.iconLink ? (
                                        isExternalLink(item.iconLink) ? (
                                            <a
                                                href={item.iconLink}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <img
                                                    src={item.icon}
                                                    alt="Icon"
                                                    className="w-24 h-24 object-contain mx-auto md:mx-0"
                                                />
                                            </a>
                                        ) : (
                                            <Link to={item.iconLink}>
                                                <img
                                                    src={item.icon}
                                                    alt="Icon"
                                                    className="w-24 h-24 object-contain mx-auto md:mx-0"
                                                />
                                            </Link>
                                        )
                                    ) : (
                                        <img
                                            src={item.icon}
                                            alt="Icon"
                                            className="w-24 h-24 object-contain mx-auto md:mx-0"
                                        />
                                    )}
                                </div>
                            )}

                            {/* Title */}
                            <h3 className="text-2xl font-semibold text-gray-900 dark:text-white">
                                {item.title}
                            </h3>

                            {/* Description */}
                            {item.description && (
                                <p
                                    className="text-slate-600 dark:text-slate-400 mt-3"
                                    dangerouslySetInnerHTML={{ __html: item.description }}
                                />
                            )}

                            {/* BUTTON LINK */}
                            {item.btnName && item.btnLink && (
                                <div className="mt-5">
                                    {isExternalLink(item.btnLink) ? (
                                        <a
                                            href={item.btnLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="inline-flex justify-center items-center text-center w-38 bg-black text-white px-4 py-2 rounded hover:bg-gray-800 transition-colors duration-300"
                                        >
                                            {item.btnName}
                                        </a>
                                    ) : (
                                        <Link
                                            to={item.btnLink}
                                            className="inline-flex justify-center items-center text-center w-38 bg-black text-white px-4 py-2 rounded hover:bg-gray-800 transition-colors duration-300"
                                        >
                                            {item.btnName}
                                        </Link>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
